import { Link } from "react-router-dom";
import { CATEGORIES } from "@/mocks/archive";

export default function Categories() {
  return (
    <section className="bg-background-100 py-14 md:py-20">
      <div className="mx-auto max-w-[1200px] px-4 md:px-6">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-4">
          <div>
            <p className="flex items-center gap-2 text-xs font-semibold tracking-[0.2em] text-primary-600 uppercase">
              <span className="h-px w-8 bg-primary-400" /> Case Categories
            </p>
            <h2 className="mt-3 font-heading text-2xl md:text-4xl font-bold text-foreground-950">
              六大黑料分类档案
            </h2>
            <p className="mt-3 max-w-2xl text-sm md:text-base text-foreground-600">
              所有争议都逃不出这六类范畴。点击进入对应档案，按标签快速检索，看清每一次塌房的来龙去脉。
            </p>
          </div>
          <Link
            to="/archive"
            className="shrink-0 inline-flex items-center gap-1.5 rounded-full border border-foreground-300 px-4 py-2 text-sm font-medium text-foreground-800 hover:border-primary-400 hover:text-primary-700 transition-colors whitespace-nowrap self-start md:self-auto"
          >
            查看全部档案 <i className="ri-arrow-right-line text-sm" />
          </Link>
        </div>

        <div className="mt-10 grid gap-4 md:gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {CATEGORIES.map((c) => (
            <article
              key={c.slug}
              className="group relative flex flex-col rounded-xl border border-background-300/70 bg-background-50 p-5 md:p-6 transition-all hover:-translate-y-1 hover:border-primary-300"
            >
              <div className={`absolute inset-x-0 top-0 h-1 rounded-t-xl ${c.accent === "accent" ? "bg-accent-500" : "bg-primary-500"}`} />
              <div className="flex items-start justify-between">
                <span className={`grid place-items-center w-12 h-12 rounded-xl ${
                  c.accent === "accent" ? "bg-accent-100 text-accent-700" : "bg-primary-100 text-primary-700"
                }`}>
                  <i className={`${c.icon} text-xl`} />
                </span>
                <span className="text-[11px] font-medium text-foreground-400 tracking-wide">{c.en}</span>
              </div>
              <h3 className="mt-4 font-heading text-lg font-bold text-foreground-950">
                {c.name}
                <span className="text-primary-600">黑料</span>
              </h3>
              <p className="mt-1 text-sm text-primary-700 font-medium">{c.tagline}</p>
              <p className="mt-3 text-sm leading-6 text-foreground-600 line-clamp-3">{c.desc}</p>
              <div className="mt-4 flex flex-wrap gap-2">
                {c.sample.slice(0, 3).map((t) => (
                  <span
                    key={t}
                    className={`rounded-md px-2 py-1 text-[11px] ${
                      c.accent === "accent" ? "bg-accent-50 text-accent-800" : "bg-secondary-100 text-secondary-900"
                    }`}
                  >
                    {t}
                  </span>
                ))}
              </div>
              <Link
                to={`/archive?cat=${c.slug}`}
                className="mt-5 inline-flex items-center gap-1 text-sm font-semibold text-primary-700 hover:text-primary-800 transition-colors"
              >
                检索该分类档案
                <i className="ri-arrow-right-line text-sm transition-transform group-hover:translate-x-1" />
              </Link>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}